import { ConfigStepperClass, ConfigStepperComponentClass } from './dynamicpdf-class';
import { FilesClass } from './uploads-class';
import dayjs from 'dayjs';

export class InsuranceclaimsClass {
  idInsuranceClaims: number | null = null;
  idInsurancePolicy: number | null = null;
  InsurancePolicyDescription: string = '';
  idCompanie: number | null = null;
  CompanieName: string = '';
  CompaniesShortName: string = '';
  idCustomer: number | null = null;
  CustomerName: string = '';
  idProduct?: number | null = null;
  ProductsName: string = '';
  ProductName: string = '';
  ProductShortName: string = '';
  idProductsTypes: number | null = null;
  ProductsTypesName: string = '';
  ProductsTypesShortName: string = '';
  idPaymentsTypes: number | null = null;
  Matricula: string = '';
  MatriculaPais: string = '';
  PolicyNumber: string = '';
  idInsuranceClaimsCausesTypes: number | null = null;
  InsuranceClaimsCausesTypesDescription: string = '';
  idInsuranceClaimsStatusTypes: number | null = null;
  InsuranceClaimsStatusTypesDescription: string = '';
  InsuranceClaimsStatusTypesBackground: string = '';
  InsuranceClaimsStatusTypesTextColor: string = '';
  insuranceClaimsFiles: FilesClass[] = [];

  ProductsIcon: Image | null = null;
  Description: string = '';
  ClaimDate: Date | null = null;
  Contact: string = '';
  Reason: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  TitleForm: string = '';
  showSignature: boolean = false;
  Signature: string = '';
  Signature2: string = '';
  Email: string = '';
  EmailTo: string = '';
  ClientEmail?: string = '';
  IncidentDate?: Date | string | null = null;
  EmailSent: Date | null = null;
  ProcessNumber: string = '';

  PeritagemOficina: string = '';
  PeritagemNIF: string = '';
  PeritagemMorada: string = '';
  PeritagemContacto: string = '';
  PeritagemEmail: string = '';
  PeritagemData: Date | null = null;
  PeritagemRelatorio: string = '';

  RentCarOficina: string = '';
  RentCarMorada: string = '';
  RentCarData: Date | null = null;
  RentCarDataDevolucao?: Date | string | null = null;
  RentCarDias: number | null = null;

  Liability?: string = '';
  LiabilityText?: string = '';
  Responsabilidade?: string = '';

  UUID: string = '';
  UUIDLastChange: string = '';
  DataSource?: string = '';

  files: number | null = null;
  nome: string = '';
  isbreakingglass: boolean = false;
  ManagedBySegurosVirtual: boolean = false;
  loading: boolean = false;
  insuranceClaimsExpertiseClass: InsuranceClaimsExpertiseClass[] = [];
  insuranceClaimsRepairClass: InsuranceClaimsRepairClass[] = [];
  claimNumberExternal: string = '';
  Order: number | null = null;

  situationDescription: string = '';
  occurrenceDate: Date | null = null;
  openDate: Date | null = null;
  closeDate: Date | null = null;
  DateSync: Date | null = null;

  policyStatus: string = '';
  policyType: string = '';
  effectiveDate: Date | null = null;
  expirationDate: Date | null = null;
  claimId: string = '';
  claimLocation: string = '';
  claimOwner: string = '';
  reportedBy: string = '';
  claimStatus: string = '';
  claimStatusCode: string = '';
  lobId: string = '';
  lobDescription: string = '';
  claimComplexity: string = '';
  notificationType: string = '';
  notificationInd: string = '';
  notificationDate: Date | null = null;
  acceptanceDate: Date | null = null;
  participationDate: Date | null = null;
  reOpenDate: Date | null = null;
  reCloseDate: Date | null = null;

  AGEASDetail: AGEASDetails | null = null;
  ShowCarInspection: boolean = false;
  configStepperClass: ConfigStepperClass[] = [];
  FieldPositions: ConfigStepperComponentClass[] = [];
  JSONinsuranceClaimsQuizConfigStepperComponentClass: string = '';
  insuranceClaimsConfigPDFClass: FilesClass | null = null;
  DadosValid: boolean | null = null;

  Name: string = '';
  NIF: string = '';
  LastName: string = '';
  CCNumber: string = '';
  CCDateValidate: Date | null = null;
  CCLifelong: boolean = false;
  Birthdate: Date | null = null;
  idSexTypes: number | null = null;
  Sexo: string = '';
  idMaritalStatus: number | null = null;
  Country: string = '';
  Profession: string = '';
  CAE: string = '';
  PlaceOfBirth: string = '';
  Nationality: string = '';
  Drivinglicense: string = '';
  DrivinglicenseDate: Date | null = null;
  DrivinglicenseExpirationDate: Date | null = null;
  ShowNIB: boolean = false;
  NIB: string = '';
  idBillingAddress: number | null = null;
  idShipToAddress: number | null = null;
  AddressDetail: string = '';
  PostalCode: string = '';
  Region: string = '';
  PostalCodeRegion: string = '';
  Employer: string = '';
  DriverSameAsHolder: boolean = false;

  MatriculaDados: string = '';
  Capital: number | null = null;
  Salario: number | null = null;
  DateStartPolicy: Date | null = null;
  DateEndPolicy: Date | null = null;
  ClaimHour: string | null = null;

  AutorizacaoDebitoText: string = '';
  AutorizacaoDebitoNome: string = '';
  AutorizacaoDebitoIBAN: string = '';
  Price: string = '';

  public parseDates() {
    const dateFields = [
      'ClaimDate',
      'DateStart',
      'DateEnd',
      'EmailSent',
      'PeritagemData',
      'RentCarData',
      'occurrenceDate',
      'openDate',
      'closeDate',
      'DateSync',
      'effectiveDate',
      'expirationDate',
      'notificationDate',
      'acceptanceDate',
      'participationDate',
      'reOpenDate',
      'reCloseDate',
      'CCDateValidate',
      'Birthdate',
      'DrivinglicenseDate',
      'DrivinglicenseExpirationDate',
      'DateStartPolicy',
      'DateEndPolicy',
    ];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          if (f === 'ClaimDate' && !this.ClaimHour) {
            this.ClaimHour = d.format('HH:mm');
          }
          this[f] = d;
        }
      }
    });

    if (this.insuranceClaimsExpertiseClass) {
      this.insuranceClaimsExpertiseClass.forEach(x => {
        if (x.parseDates) x.parseDates();
      });
    }
    if (this.insuranceClaimsRepairClass) {
      this.insuranceClaimsRepairClass.forEach(x => {
        if (x.parseDates) x.parseDates();
      });
    }
  }
}

export class InsuranceClaimsCausesTypesClass {
  idInsuranceClaimsCausesTypes: number | null = null;
  Description: string = '';
  Background: string = '';
  TextColor: string = '';
  Icon: null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: number | null = null;
  Order: number | null = null;
  idCompanieDefault: number | null = null;
  Email: string = '';
  isbreakingglass: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class InsuranceClaimsStatusTypesClass {
  idInsuranceClaimsStatusTypes: number | null = null;
  Description: string = '';
  Background: string = '';
  TextColor: string = '';
  Icon: null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: number | null = null;
  Order: number | null = null;
  SabSeg: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class Image {
  type: string = '';
  data: number[] = [];
}

export class InsuranceclaimsExportClass {
  Companhia: string = '';
  Cliente: string = '';
  Seguro: string = '';
  Produto: string = '';
  Matricula: string = '';
  Apolice: string = '';
  Estado: string = '';
  Descricao: string = '';
  Contacto: string = '';
  Motivo: string = '';
}

export class InsuranceclaimsMessages {
  idInsuranceClaimsMessage: number | null = null;
  idInsuranceClaims: number | null = null;
  Subject: string = '';
  Text: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  idInsuranceClaimsMessageOwner: number | null = null;
  fromidCommercial: number | null = null;
  toidCommercial: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  insuranceclaimsMessagesFiles: InsuranceclaimsMessagesFilesClass[] = [];
  stepperDialogComponent = 'StepperComponent';
}

export class InsuranceclaimsMessagesFilesClass {
  idInsuranceClaimsMessageFiles: number | null = null;
  idInsuranceClaimsMessage: number | null = null;
  subjectfile: string = '';
  DocumentName: string = '';
  updated: Date | null = null;
  FilePath: string = '';
  type: string = '';
  size: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class InsuranceClaimsExpertiseClass {
  idInsuranceClaimsExpertise: number | null = null;
  idInsuranceClaims: number | null = null;
  idInsuranceClaimsExpertiseStatus: null = null;
  DateContact: Date | null = null;
  DateExpertise: Date | null = null;
  DateConclusion: Date | null = null;
  InjuryAssessment: string = '';
  Value: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateContact', 'DateExpertise', 'DateConclusion', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class InsuranceClaimsRepairClass {
  idInsuranceClaimsRepair: number | null = null;
  idInsuranceClaims: number | null = null;
  Oficina: string = '';
  Morada: string = '';
  DatePrevInit: Date | null = null;
  DiasEstimados: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DatePrevInit', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class InsuranceClaimsResumeClass {
  idInsuranceClaimsResumo: number | null = null;
  idInsuranceClaims: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

// Generated by https://quicktype.io

export class InsuranceClaimsOficinasConvencionadasClass {
  idInsuranceClaimsOficinasConvencionadas: number | null = null;
  idCompanie: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  PeritagemOficina: string = '';
  PeritagemNIF: string = '';
  PeritagemMorada: string = '';
  PeritagemContacto: string = '';
  PeritagemEmail: string = '';
  PeritagemRelatorio: string = '';
  Aconselhamento: string = '';
  Distrito: string = '';
  Concelho: string = '';
  CodigoPostal: string = '';
  GPS: string = '';
  UUID: string = '';
  UUIDLastChange: null = null;
}

// Generated by https://quicktype.io

export class AGEASDetails {
  lead: null = null;
  lobId: string = '';
  claimId: string = '';
  itemList: ItemList[] = [];
  lineList: LineList[] = [];
  reserves: null = null;
  closeDate: null = null;
  claimOwner: string = '';
  policyType: string = '';
  reOpenDate: null = null;
  reportedBy: null = null;
  claimNumber: string = '';
  claimStatus: string = '';
  commentList: CommentList[] = [];
  paymentList: PaymentList[] = [];
  reCloseDate: null = null;
  documentList: DocumentList[] = [];
  policyNumber: string = '';
  policyStatus: string = '';
  claimLocation: string = '';
  companyNumber: string = '';
  effectiveDate: string = '';
  acceptanceDate: string = '';
  expirationDate: string = '';
  lobDescription: null = null;
  activictiesList: ActivictiesList[] = [];
  claimComplexity: string = '';
  claimStatusCode: string = '';
  notificationInd: string = '';
  notificationDate: string = '';
  notificationType: string = '';
  participantsList: ParticipantsList[] = [];
  participationDate: string = '';
  permanentIncapacityList: null = null;
  temporaryIncapacityList: null = null;
}

export class PaymentList {
  receiptNumber: string = '';
  receiptType: string = '';
  receiverName: string = '';
  receiverType: string = '';
  value: number | null = null;
  status: string = '';
  rubric: string = '';
  description: string = '';
  lineNumber: string = '';
  paymentId: string = '';
  paymentType: string = '';
  paymentOrigin: string = '';
  approvalDate: Date | null = null;
  created: Date | null = null;
  lastUpdate: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['approvalDate', 'created', 'lastUpdate'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class ActivictiesList {
  title: string = '';
  status: string = '';
  taskId: string = '';
  message: string = '';
  userName: string = '';
  limitDate: string = '';
}

export class CommentList {
  userName: string = '';
  commentId: string = '';
  lineNumber: string = '';
  commentDate: string = '';
  commentTitle: string = '';
  commentDescription: string = '';
}

export class DocumentList {
  fileName: string = '';
  documentID: string = '';
  description: string = '';
  documentDate: string = '';
  documentType: string = '';
  documentSubType: string = '';
}

export class ItemList {
  brand: string = '';
  itemId: string = '';
  objectName: string = '';
  objectType: string = '';
  licensePlate: string = '';
  objectSubType: string = '';
  lobDescription: string = '';
}

export class LineList {
  coverage: string = '';
  lineType: string = '';
  acceptLine: boolean = false;
  complexity: string = '';
  lineNumber: string = '';
  lineStatus: string = '';
  statusDate: string = '';
  liabilityStatus: string = '';
  liabilityPercent: string = '';
}

export class ParticipantsList {
  city: string = '';
  country: string = '';
  zipCode: string = '';
  taxNumber: string = '';
  clientName: string = '';
  streetName: string = '';
  addressType: string = '';
  clientRoles: string = '';
  contactlist: Contactlist[] = [];
  clientNumber: string = '';
  involvementRoleId: string = '';
}

export class Contactlist {
  contact: string = '';
  contactType: string = '';
}

export class InsuranceClaimsLeadClass {
  idInsuranceClaimsLead: number | null = null;
  idInsuranceClaims: number | null = null;
  leadType: string = '';
  endDate: Date | null = null;
  beginDate: Date | null = null;
  providerid: string = '';
  rentalDays: number | null = null;
  repairDays: number | null = null;
  serviceType: string = '';
  scheduleDate: Date | null = null;
  appraisalCost: string = '';
  serviceNumber: string = '';
  serviceStatus: string = '';
  evaluationType: string = '';
  schedulePeriod: string = '';
  appraisalStatus: string = '';
  serviceProvider: string = '';
  estimatedEndDate: Date | null = null;
  serviceRequestDate: Date | null = null;
  estimatedRepairDays: number | null = null;
  expectedBeginRepair: Date | null = null;
  leadNumber: string = '';
  leadStatus: string = '';
  lineNumber: number | null = null;
  leadContactDate: Date | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = [
      'endDate',
      'beginDate',
      'scheduleDate',
      'estimatedEndDate',
      'serviceRequestDate',
      'expectedBeginRepair',
      'leadContactDate',
      'DateStart',
      'DateEnd',
    ];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class InsuranceClaimsPaymentListClass {
  idInsuranceClaimsPaymentList: number | null = null;
  idInsuranceClaims: number | null = null;
  paymentId: string = '';
  leadNumber: string = '';
  value: number | null = null;
  rubric: string = '';
  status: string = '';
  created: Date | null = null;
  lastUpdate: Date | null = null;
  lineNumber: string = '';
  description: string = '';
  paymentType: string = '';
  receiptType: string = '';
  approvalDate: Date | null = null;
  receiverName: string = '';
  receiverType: string = '';
  paymentOrigin: string = '';
  receiptNumber: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['created', 'lastUpdate', 'approvalDate', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class InsuranceClaimsLineListClass {
  idInsuranceClaimsLineList: number | null = null;
  lineNumber: string = '';
  leadNumber: string = '';
  coverage: string = '';
  lineType: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
  acceptLine: boolean | null = null;
  complexity: string = '';
  lineStatus: string = '';
  statusDate: Date | null = null;
  liabilityStatus: string = '';
  liabilityPercent: string = '';

  public parseDates() {
    const dateFields = ['DateStart', 'DateEnd', 'statusDate'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class InsuranceClaimsCommentListClass {
  idInsuranceClaimscommentList: number | null = null;
  idInsuranceClaims: number = 0;
  userName: string = '';
  commentId: string = '';
  lineNumber: string = '';
  commentDate: Date | null = null;
  commentTitle: string = '';
  commentDescription: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  public parseDates() {
    const dateFields = ['commentDate', 'DateStart', 'DateEnd'];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });
  }
}

export class AuxClaimsPolicyNumbersClass {
  idInsurancePolicy: number | null = null;
  PolicyNumber: string = '';
  Capital: number | null = null;
  Salario: number | null = null;
  Matricula: boolean = false;
  ShowMatricula: boolean = false;
  ShowCapital: boolean = false;
  ShowSalario: boolean = false;
}

// export class InsuranceClaimsQuizConfigPDFClass {
//         idInsuranceClaimsQuizConfigPDF: number | null = null;
//         idProduct: number = 0;
//         idProductsTypes: number = 0;
//         PDFProposal: Blob | null = null;
//         DateStart: Date | null = null;
//         DateEnd: Date | null = null;
//         DocumentName: string = '';
//         Description: string = '';
//         Tooltip: string = '';
//         updated: Date | null = null;
//         FilePath: string = '';
//         type: string = '';
//         size: string = '';
//         SendEmailTo: string = '';
//         SendSMSTo: string = '';
//         cc: string = '';
//         bcc: string = '';
//         subject: string = '';
//         html: string = '';
//         Order: number = 0;
//         UUIDLastChange: string = '';
//         UUID: string = '';

// }

// export class InsuranceClaimsQuizConfigPDFComponentPositionClass {
//         idInsuranceClaimsQuizConfigPDFComponentPosition: number  | null = null;
//         idInsuranceClaimsQuizConfigPDF: number  | null = null;
//         idInsuranceClaimsQuizConfigStepper: number  | null = null;
//         TextAlign: string = '';
//         FontSize: number  | null = null;
//         Height: number  | null = null;
//         FontWeight: string = '';
//         TextColor: string = '';
//         LineBreak: string = '';
//         WhiteSpace: string = '';
//         BackgroundColor: string = '';
//         DateStart: Date | null = null;
//         DateEnd: Date | null = null;
//         PDFPageNumber: number  | null = null;
//         PDFx: number  | null = null;
//         PDFy: number  | null = null;
//         PDFxx: number  | null = null;
//         PDFyy: number  | null = null;
//         Scale: number  | null = null;
//         Class: string = '';
//         FieldType: string = '';
//         FieldValuePDF: string = '';
//         FieldValueValidate: string = '';
//         Mask: string = '';
//         LetterSpacing: number  | null = null;
//         UpperCase: number  | null = null;
//         Order: number  | null = null;
//         JSON: string = '';
//         JSONArray: JSONQuiz[];
//         UUID: string = '';
//         UUIDLastChange: string = '';
//     }

// export class InsuranceClaimsQuizConfigStepperClass {
//         idInsuranceClaimsQuizConfigStepper: number | null = null;
//         idInsuranceClaimsQuizConfigPDF: number  | null = null;
//         idCompanie: number = 0;
//         idProduct: number = 0;
//         idProductsTypes: number = 0;
//         PDFProposal: Blob | null = null;
//         Name: string = '';
//         ShortName: string = '';
//         Description: string = '';
//         comments: string = '';
//         matStepperIcon: string = '';
//         optional: boolean = false;
//         editable: boolean = false;
//         matStepperPrevious: boolean = false;
//         matStepperNext: boolean = false;
//         TextColor: string = '';
//         BackgroundColor: string = '';
//         DateStart: Date | null = null;
//         DateEnd: Date | null = null;
//         Order: number  | null = null;
//         editMode: boolean = false;
//         DocumentName: string = '';
//         Tooltip: string = '';
//         updated: Date | null = null;
//         FilePath: string = '';
//         type: string = '';
//         size: string = '';
//         SendEmailTo: string = '';
//         SendSMSTo: string = '';
//         cc: string = '';
//         bcc: string = '';
//         subject: string = '';
//         html: string = '';
//         extraStepper: boolean = false;
//         UUIDLastChange: string = '';
//         UUID: string = '';
//         configStepperComponentClass: ConfigStepperComponentClass[] = [];
// }

export class InsuranceClaimsFeaturesClass {
  idInsuranceClaimsFeatures: number | null = null;
  Group: string = '';
  Description: string = '';
  Image: string = ''; // You might want to use a URL, base64, or another method
  width: number = 0; // Image width
  height: number = 0; // Image height
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  x: number | null = null;
  y: number | null = null;
  rotation: number | null = null;
  BringToFront: boolean = false;
  isText: boolean = false;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}
